export default {
  submit: '确定',
  loading: '加载中...',
  tokenInfoTitle: '代币信息',
  tokenDetectionTitle: '安全检测',
  baseInfo: '基本信息',
  projectSymbol: '项目代码',
  projectName: '项目名称',
  contractAddress: '合约地址',
  contractOwner: '合约owner',
  website: '官方网站',
  socialInfo: '社交信息',
  more: '更多',
  releaseInfo: '发行信息',
  releaseTotal: '发行总量',
  releaseTime: '发行时间',
  securityInfo: '安全信息',
  moreSecurityInfo: '前往查看更多安全信息',
  detection: '检测',
  network: '选择网络',
  detectionDesc:
    '安全检测结果基于链上数据分析，仅供参考。这并不意味着数据是 100% 正确的。请始终进行自己的研究并承担相应的风险。TokenPocket 将致力于为用户提供更多有用的数据。',
  securityOverview: '安全概括',
  risky: '危险警告',
  attentionTip: '安全提示',
  contractCreator: '合约创造者',
  circulation: 'Circulation',
  tradingSecurityReport: '交易安全报告',
  buy_tax: '买入税率 {tax}',
  sell_tax: '卖出税率 {tax}',
  unknown_tax: '未知税率',
  contractSecurityReport: '合约安全报告',

  trade_0_text1: '这看上去不像是貔貅',
  trade_0_text2: '交易税率不可修改',
  trade_0_text3: '交易不能暂停',
  trade_0_text4: '没有黑名单功能',
  trade_0_text5: '没有白名单功能',
  trade_0_text6: '没有防巨鲸功能',
  trade_0_text7: '可以买入',
  trade_0_text8: '可以全部卖出',
  trade_0_text9: '没有交易冷却',
  trade_0_text10: '没有针对个人设置滑点',
  trade_0_text11: '没有修改最大卖出或转移的功能',

  trade_1_text1: '这是一个貔貅',
  trade_1_text2: '交易税率可修改',
  trade_1_text3: '交易可以暂停',
  trade_1_text4: '有黑名单功能',
  trade_1_text5: '有白名单功能',
  trade_1_text6: '有防巨鲸功能',
  trade_1_text7: '无法买入',
  trade_1_text8: '不可以全部卖出',
  trade_1_text9: '有交易冷却',
  trade_1_text10: '有针对个人设置滑点',
  trade_1_text11: '有修改最大卖出或转移的功能',

  trade_2_text1: '权限已转移，无法设置暂停交易',
  trade_2_text2: '权限已转移，无法设置交易税',
  trade_2_text3: '权限已转移，无法设置交易冷却',
  trade_2_text4: '权限已转移，无法更新最大卖出',

  trade_token_status_text1: '该代币被标记为恶意或钓鱼代币，切勿交互',

  airdropScam: '这是一个空投诈骗',
  fakeToken: '这是一个假币',
  contract_0_text1: '合约代码已开源',
  contract_0_text2: '没有代理合约',
  contract_0_text3: '没有增发的功能',
  contract_0_text4: '拥有者不能修改余额',
  contract_0_text5: '没有隐藏的拥有者',
  contract_0_text6: '没有取回所有权',
  contract_0_text7: '不可自毁合约',
  contract_0_text8: '不存在外部方法',

  contract_1_text1: '合约代码没有开源',
  contract_1_text2: '有代理合约',
  contract_1_text3: '有增发的功能',
  contract_1_text4: '拥有者可以修改余额',
  contract_1_text5: '有隐藏的拥有者',
  contract_1_text6: '有取回所有权',
  contract_1_text7: '可自毁合约，资产会归零',
  contract_1_text8: '存在外部方法',

  contract_2_text1: '权限已转移，无法进行增发',
  contract_2_text2: '权限已转移，无法修改余额',

  copySuccess:
    '已复制。请注意，您复制的地址属于合约地址，请不要往该地址转账，否则无法找回资产！',
  report: '举报',
  placeholder: '请输入代币合约地址',

  errorContract: '请求的数据有误，请确认合约是否正确',
  errorData: '没有请求到数据，请您稍后重试',
  understood: '好的',
  copySuccess2: '复制成功',
  copySuccess3: '链接复制成功',

  is_honeypot: '貔貅就是无法进行卖出的代币，这种代币没有价值',
  locked: '锁仓',
  smartContract: '合约账号',

  liquidityPool: '流动性池子',
  poolInfo: '池子信息',
  lockedPercent: '锁仓比例',
  amm: 'AMM',
  pair: '池子对',
  amount: '数量',
  liquidity: '流动性',

  share_report: '分享',
  check_report: 'Check Report',
  contract_ownership: '开发者已放弃合约所有权',
  chain_not_found: '查无此链～',
  settings: '设置',
  languages: '语言',
  search_placeholder: '请输入网络名称',
  darkmode: 'Dark Mode',

  tokenHolders: '代币持有者',
  top10Holders: '前十持有者',
  LPHolders: 'LP持有者',
  holdersNumber: '持有者人数',

  SOL: {
    ownerProgram: 'Owner程序',
    ownerProgram_1: 'Token Program',
    ownerProgram_2: 'Token 2022 Program',
    current_fee_rate_1: '当前交易税率',
    current_fee_rate_2: '单次交易最大税额',
    current_fee_rate_3: '当前交易税率: 未知税率',
    scheduled_fee_rate:
      '交易税将在 epoch {epoch1} 变更为 {tax}%。当前epoch: {epoch2}',
    scheduled_fee_rate_1:
      '交易税已在 epoch {epoch1} 变更为 {tax}%。当前epoch: {epoch2}',

    trade_0_text1: '代币可以正常使用',
    trade_0_text2: '可转账的代币',
    trade_0_text3: '合约创造者地址不是恶意地址',
    trade_0_text4: '代币没有外部程序',
    trade_0_text5: '著名代币或值得信任的代币',

    trade_1_text1: '新创建的代币，还未激活',
    trade_1_text4: '有外部程序',
    trade_1_text5: '非著名或不在信任名单内的代币',

    trade_2_text1: '代币已被冻结，无法正常交易',
    trade_2_text2: '无法转账的代币',
    trade_2_text3: '合约创造者地址是恶意地址',
    trade_2_text4: '代币有外部程序，且外部程序合约为恶意合约！',

    contract_0_text1: '代币元数据不可变更',
    contract_0_text2: '没有增发功能',
    contract_0_text3: '交易不能被冻结',
    contract_0_text4: '代币不可被开发者关闭',
    contract_0_text5: '交易税率不可升级',
    contract_0_text6: '默认账户状态不可升级',
    contract_0_text7: '开发者不能修改余额',
    contract_0_text8: '外部程序不可升级',

    contract_1_text1: '代币元数据可变更，但无地址拥有变更权限',
    contract_1_text2: '有增发的功能',
    contract_1_text3: '交易可被冻结',
    contract_1_text5: '交易税率可升级',
    contract_1_text6: '默认账户状态可升级',
    contract_1_text8: '外部程序可升级',

    contract_2_text1: '存在拥有变更代币元数据权限的地址',
    contract_2_text4: '代币可被开发者随时关闭',
    contract_2_text7: '开发者可以修改余额',

    transfer_hook: '外部程序可能会阻止交易',
    transfer_hook_1: '外部程序合约:',
    metadata_mutable: '有变更权限的地址:',
    trading: '基本信息安全报告',
    contract: '代币功能和风险分析',
  },

  tokenSecurityData: {
    trade_0_text1: '这看上去不像是貔貅',
    trade_0_text2: '交易税率不可修改',
    trade_0_text3: '交易不能暂停',
    trade_0_text4: '没有黑名单功能',
    trade_0_text5: '没有白名单功能',
    trade_0_text6: '没有防巨鲸功能',
    trade_0_text7: '可以买入',
    trade_0_text8: '可以全部卖出',
    trade_0_text9: '没有交易冷却',
    trade_0_text10: '没有针对个人设置滑点',
    trade_0_text11: '没有修改最大卖出或转移',

    trade_1_text1: '这是一个貔貅',
    trade_1_text2: '交易税率可修改',
    trade_1_text3: '交易可以暂停',
    trade_1_text4: '有黑名单功能',
    trade_1_text5: '有白名单功能',
    trade_1_text6: '有防巨鲸功能',
    trade_1_text7: '无法买入',
    trade_1_text8: '不可以全部卖出',
    trade_1_text9: '有交易冷却',
    trade_1_text10: '有针对个人设置滑点',
    trade_1_text11: '有修改最大卖出或转移',

    trade_2_text1: '权限已转移，无法设置暂停交易',
    trade_2_text2: '权限已转移，无法设置交易税',
    trade_2_text3: '权限已转移，无法设置交易冷却',
    trade_2_text4: '权限已转移，无法更新最大卖出',

    trade_token_status_text1: '该代币被标记为恶意或钓鱼代币，切勿交互',

    airdropScam: '这是一个空投诈骗',
    fakeToken: '这是一个假币',
    contract_0_text1: '合约代码已开源',
    contract_0_text2: '没有代理合约',
    contract_0_text3: '没有增发的功能',
    contract_0_text4: '拥有者不能修改余额',
    contract_0_text5: '没有隐藏的拥有者',
    contract_0_text6: '没有取回所有权',
    contract_0_text7: '不可自毁合约',
    contract_0_text8: '不存在外部方法',

    contract_1_text1: '合约代码没有开源',
    contract_1_text2: '有代理合约',
    contract_1_text3: '有增发的功能',
    contract_1_text4: '拥有者可以修改余额',
    contract_1_text5: '有隐藏的拥有者',
    contract_1_text6: '有取回所有权',
    contract_1_text7: '可自毁合约，资产会归零',
    contract_1_text8: '存在外部方法',

    contract_2_text1: '权限已转移，无法进行增发',
    contract_2_text2: '权限已转移，无法修改余额',

    buy_tax: '买入税率 {tax}',
    sell_tax: '卖出税率 {tax}',
    unknown_buy_tax: '买入税率未知',
    unknown_sell_tax: '卖出税率未知',
    unknown_tax: '未知税率',
    // is_honeypot: '貔貅就是无法进行卖出的代币，这种代币没有价值',
    info: '安全详情',

    desc: '安全检测结果仅用于代币安全性的参考评估，不代表完全准确，也不构成任何形式的背书或投资建议。进行代币交易前，请务必自行充分研究与分析。',
    hightRiskToken: '被社区标记为危险代币，请注意风险',
    liquidityLow: '流动性 ≤ $5K，交易此代币可能导致资产损失',
    scanOverview: '扫描总览',
    taxRate: '税率',
    testItems: '检测项',
    buyTax: '买入税',
    sellTax: '卖出税',
    highRisk: '高风险',
    mediumRisk: '中风险',

    is_open_source: '代码开源',
    is_open_source_tip:
      '合约代码开源意味着可以在链上看到该代币的源代码，如果未开源，合约的真实性',
    is_proxy: '代理合约',
    is_proxy_tip:
      '代理合约允许项目方通过代理合约来修改该代币合约的核心功能，存在被篡改风险',
    is_mintable: '是否有增发功能',
    is_mintable_tip:
      '增发功能允许项目方任意增加代币总量，可能造成通胀或价值稀释',
    owner_change_balance: '是否可以修改用户余额',
    owner_change_balance_tip:
      'Owner拥有修改用户余额的权限时，可能导致资产被直接操控或清零',
    can_take_back_ownership: '是否可以取回源所有权',
    can_take_back_ownership_tip:
      '可取回所有权的合约允许项目方重新掌控代币合约权限，增加被更改或干预风险',
    hidden_owner: '是否有隐藏owner',
    hidden_owner_tip:
      '隐藏的Owner地址意味着存在未公开的控制者，可能绕过普通检测限制进行操作',
    is_honeypot: '貔貅代币',
    is_honeypot_tip: '貔貅代币通常允许买入但限制卖出，你的资金可能被永久锁定',
    transfer_pausable: '可暂停交易',
    transfer_pausable_tip:
      '暂停交易功能允许项目方随时暂停买卖，可能导致你无法正常出售代币',
    cannot_buy: '无法买入',
    cannot_buy_tip: '无法买入的代币意味着你无法进行购买，可能存在欺诈风险',
    cannot_sell_all: '无法全部卖出',
    cannot_sell_all_tip:
      '出售限制意味着你无法一次性卖出全部代币，部分资金被锁定',
    trading_cooldown: '是否有交易冷却',
    trading_cooldown_tip:
      '交易冷却机制会在两次交易间强制设定间隔，限制你的自由交易',
    is_anti_whale: '是否有防巨鲸限制',
    is_anti_whale_tip:
      '防巨鲸机制通过限制交易金额或持仓比例来防止大额操作，可能影响正常交易',
    slippage_modifiable: '交易税可改',
    slippage_modifiable_tip:
      '可修改交易税率的合约意味着项目方可临时提高税费，导致买卖损失',
    is_blacklisted: '是否存在黑名单功能',
    is_blacklisted_tip:
      '黑名单功能允许合约阻止特定地址进行交易，黑名单用户无法买卖代币',
    is_whitelisted: '是否存在白名单功能',
    is_whitelisted_tip:
      '白名单机制允许合约仅允许特定地址交易，普通用户可能被排除在外',
    anti_whale_modifiable: '是否可修改防巨鲸限制',
    anti_whale_modifiable_tip:
      '可修改防巨鲸限制意味着owner可以修改限制交易金额或持仓比例，以限制交易',
    is_true_token: '是否为真币',
    is_true_token_tip: '假币可能仿冒官方代币名称或Logo，以欺骗购买或授权资产',
    is_airdrop_scam: '空投诈骗',
    is_airdrop_scam_tip:
      '空投诈骗通常伪装为福利发放，诱导你的授权，从而盗取钱包资产',
    selfdestruct: '可自毁',
    selfdestruct_tip:
      '自毁功能意味着项目方可以销毁合约，从而导致代币永久失效或资产丢失',
    external_call: '是否有外部调用风险',
    external_call_tip:
      '外部调用意味着合约依赖外部合约调用，若外部合约异常或被攻击，可能影响该代币的正常运行',
    personal_slippage_modifiable: '是否可修改指定地址的税率',
    personal_slippage_modifiable_tip:
      'Owner拥有此权限意味着可以为指定地址设定特殊税率，以阻止其交易',
    trust_list: '信任名单',

    can_self_destruct: '可自毁',
    can_self_destruct_tip:
      '自毁功能意味着项目方可以销毁合约，从而导致代币永久失效或资产丢失',
    major_holder_ratio: '大户集中度过高',
    major_holder_ratio_tip:
      '若前20地址持币比例过高，少数大户可轻易操纵价格或流动性，影响市场公平性',
    has_external_calls: '是否有外部调用风险',
    has_external_calls_tip:
      '外部调用意味着合约依赖外部合约调用，若外部合约异常或被攻击，可能影响该代币的正常运行',

    buyTaxTip:
      '买入税过高可能意味着存在隐藏税费或陷阱，高税率会导致买入时收到的代币减少',
    sellTaxTip: '卖出税过高可能导致实际获得金额大幅减少，甚至无法完全卖出',
  },

  solTokenSecurityData: {
    fee_in_basis_points: '手续费',
    fee_in_basis_points_tip:
      '高额手续费可能会在每笔交易中消耗大量资金，导致买卖代币时损失较大，影响资产流动性和可交易性',
    freezable: '交易冻结',
    freezable_tip:
      '交易冻结功能允许合约在特定情况下阻止所有买卖操作，这可能导致用户在需要时无法转出或出售代币',
    transfer_fee_upgradable: '交易税率可更改',
    transfer_fee_upgradable_tip:
      '高交易税率会提高你的买入成本和卖出收益，显著降低你的的实际收益；调整交易税率的合约也可能带来额外风险，例如增加税费100%以阻止卖出',
    interest_rate: '是否有利率机制',
    interest_rate_tip:
      '带有利率机制的代币其价值计算更复杂，智能合约逻辑也更繁琐，增加了代码漏洞的可能性，也更难评估代币价值',
    rate_authority: '是否能更改利率',
    rate_authority_tip:
      '存在能更改利率的地址，意味着此代币的利率随时会被更改，有可能造成资产损失。',
    liquidity_control: '流动性分布是否正常',
    liquidity_control_tip:
      '如果大部分流动性由一个或少数几个地址控制，他们可以随时撤走流动性池中的资金，导致代币失去交易能力，价格归零',
    major_holders_ratio: '持有人分布是否正常',
    major_holders_ratio_tip:
      '如果前几名持有人持有过多代币，他们可以轻易地在市场上大量抛售（砸盘）导致价格暴跌，或者通过拉盘出货来操纵市场',
    initial_distribution: '初始分配分布是否正常',
    initial_distribution_tip:
      '检查代币诞生时的分配是否公平。如果初始分配就高度集中，通常预示着项目方预留了大量代币用于后续抛售，即“预挖”陷阱',
    transfer_fee_authority: '是否存在手续费授权权限',
    transfer_fee_authority_tip:
      '如果存在此权限，某个地址可以随意更改转账手续费，增加用户交易成本，甚至通过高额手续费变相锁定资产',
    transfer_fee_extension: '是否存在手续费拓展功能',
    transfer_fee_extension_tip:
      '代币内置了转账扣费功能，每一笔转账都可能被自动扣除手续费，如果存在手续费更改权限，风险会更高。',
    confidential_transfer_extension: '是否存在保密转账功能',
    confidential_transfer_extension_tip:
      '该功能会加密转账金额，使你无法在链上查看该代币转账的具体数额',
    interest_bearing_token_extension: '有息代币',
    interest_bearing_token_extension_tip:
      '有息代币指的是带有利率机制的代币，其智能合约逻辑更繁琐，增加了代码漏洞的可能性，也更难评估代币价值',
    default_account_state: '代币创建状态是否正常',
    default_account_state_tip:
      '代币的创建状态显示其是否为正式部署版本。若代币尚未完成激活，可能存在被替换或修改的风险，甚至冻结交易',
    non_transferable: '代币是否能转账',
    non_transferable_tip:
      '无法转账的代币会限制地址之间的转账，或仅允许合约内部交易，可能导致你的资产无法自由交易',
    non_transferable_token_extension: '代币是否能转账',
    non_transferable_token_extension_tip:
      '无法转账的代币会限制地址之间的转账，或仅允许合约内部交易，可能导致你的资产无法自由交易',
    creators: '创建者是恶意地址',
    creators_tip:
      '若合约创建者是恶意地址，可能存在诈骗或恶意操作风险，如锁仓、税率操纵等',
    transfer_hook: '是否存在外部程序',
    transfer_hook_warning_tip:
      '有外部程序意味着合约会被外部程序调用和控制，外部程序可能会阻止交易',
    transfer_hook_danger_tip:
      '有外部程序意味着合约会被外部程序调用和控制，外部程序可能会阻止交易，且当前代币存在恶意外部程序与地址:',
    transfer_hook_extension: '是否存在外部程序',
    transfer_hook_extension_tip:
      '有外部程序意味着合约会被外部程序调用和控制，外部程序可能会阻止交易',
    trusted_token: '信任代币',
    trusted_token_tip:
      '被第三方平台列入信任名单的代币，但不保证完全可信，交易前请确认这是你所信任的代币。',
    metadata_mutable: '代币元数据可变更',
    metadata_mutable_warning_tip:
      '代币元数据可修改，意味着代币名称、符号或精度可被修改，当前代币元数据可变更，但无地址拥有变更权限',
    metadata_mutable_danger_tip:
      '代币元数据可修改，意味着代币名称、符号或精度可被修改，当前代币元数据可变更，且存在拥有变更权限的地址',
    mintable: '是否存在增发功能',
    mintable_tip: '增发功能允许项目方任意增加代币总量，可能造成通胀或价值稀释',
    mint_authority: '是否存在增发功能',
    mint_authority_tip:
      '增发功能允许项目方任意增加代币总量，可能造成通胀或价值稀释',
    closable: '是否存在关闭功能',
    closable_tip: '关闭功能允许项目方随时关闭代币，可能导致资产损失',
    closing_mint_extension: '是否存在关闭功能',
    closing_mint_extension_tip:
      '关闭功能允许项目方随时关闭代币，可能导致资产损失',
    default_account_state_upgradable: '账户状态可升级',
    default_account_state_upgradable_tip:
      '合约可升级意味着开发者能修改底层逻辑，带来灵活性的同时也存在后门与安全风险',
    balance_mutable_authority: '修改余额',
    balance_mutable_authority_tip:
      '开发者可修改余额意味着开发者能直接更改账户余额，可能导致你的资产被任意增减或清空的风险',
    transfer_hook_upgradable: '外部程序可升级',
    transfer_hook_upgradable_tip:
      '如果外部程序具备可升级权限，开发者或外部控制方可随时替换或修改合约逻辑，可能引入恶意代码、篡改交易规则或导致资产风险',
    token_launch_time: '新代币',
    token_launch_time_tip: '这是一个新创建的代币',
    withdraw_withheld_authority: '是否存在收回授权',
    withdraw_withheld_authority_tip:
      '这是一个可以从所有账户中收回被扣留代币（例如转账费）的权限，可能被滥用以提取用户资金',
    permanent_delegate_extension: '是否存在代表拓展',
    permanent_delegate_extension_tip:
      '拥有此权限的地址可以随时任意地销毁或转移任何地址中的该代币，相当于完全控制你的资产',
    scheduled_fee_rate: '交易税是否可调整',
    scheduled_fee_rate_tip:
      '交易税可调整意味着开发者可以随时调整交易税率，可能会突然提高买卖税，从而导致无法卖出或大幅减少你的收益，带来资产损失风险',
    scheduled_fee_rate_tip_1:
      '交易税将在 epoch {epoch1} 变更为 {tax}%。当前epoch: {epoch2}',
    scheduled_fee_rate_tip_2:
      '交易税已在 epoch {epoch1} 变更为 {tax}%。当前epoch: {epoch2}',
    scheduled_fee_rate_tip_future: '并且将在 epoch {epoch1} 变更为 {tax}%。',
    scheduled_fee_rate_tip_past: '交易税已在 epoch {epoch1} 变更为 {tax}%，',
    scheduled_fee_rate_tip_current_epoch: '当前epoch: {epoch2}',
  },

  testingParty: '检测方',
  currentFee: '当前买卖税率',
  tokenSecurityTip: '由于部分合约可修改参数值，因此该安全信息仅做参考',
  unknown: '未知',
};
